module.exports = __webpack_public_path__ + "static/media/grave.88386b95.jpg";